import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const NoBranchInvolved = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.noBranchInvolved`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          input={(props) => (
            <CheckBox
              {...props}
              checkBoxLabel="If no branch activity involved, check this box"
              data-qa="form_no_branch_involved"
            />
          )}
        />
      )}
    />
  )
}
